export const getFormattedDate = (date, type) => {
  switch (type) {
    case 'ISO':
      return new Date(date).toLocaleString('NL', { dateStyle: 'short' });
    case 'timestamp':
      return new Date(date.seconds * 1000).toLocaleString('NL', {
        dateStyle: 'short',
      });
    default:
      return date;
  }
};

export default getFormattedDate;
